<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs/>
      <div class="content mt-3">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->
          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('InvoiceInbounds.title')}}</strong>
                <span class="float-right">{{$t('InvoiceInbounds.text')}}</span>
                <div class="float-right">
                  <router-link v-if="HelperRole.hasRights(state, [14],[16])" :to="{ path: '/invoiceinbound'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInbounds.new')}}</router-link>

                  <!--<router-link :to="{ path: '/invoiceinbound'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('InvoiceInbounds.new')}}</router-link>-->
                </div>
              </div>
              <div class="card-body card-block fColumn fColumn">
                <div class="fContent">
                  <TableDatatableJs :head="head" :data="data"/>

                </div>
              </div>
            </div>
          </div>

        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>
</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import TableDatatableJs from '@/components/TableDatatableJs.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Helper from '@/helper/Helper';

  import Api from '@/api/Api';
  import HelperRole from '@/helper/HelperRole';
  import AlertInPage from '@/components/AlertInPage.vue';

  export default {
    name: 'InvoiceInboundsFinance',
    data() {
      const modul = this;
      // "id","id_company","text"
      return {
//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper
        ,

        data: [],
        head: [
          {
            modulname: "InvoiceInboundsFinance",
            title: "InvoiceInbounds.dttitle",
            data: "id",
            link: true,
            linkurl: "invoiceinbound",
            linkclass: "text-nowrap",
            linkiconclass: "menu-icon fa fa-edit btn-link",
            linktext: "", // InvoiceInbounds.linktext
          }
          , {
            key: "wf_status",
            title: "InvoiceInbounds.wf_status",
          }
          , {
            key: "dt_paymentdeadline",
            title: "InvoiceInbounds.dt_paymentdeadline",
          }
          , {
            key: "identifier",
            title: "Document.identifier",
            searchField: true
          }
          , {
            key: "price_sum",
            title: "InvoiceInbounds.price_sum",
          }
          , {
            key: "from_businesspartnername",
            title: "Document.from_businesspartnername",
          }
          , {
            key: "deleted",
            title: "global.deleted",
            searchField: true
          }


        ]
        , breadcrumbstitle: 'InvoiceInbounds.title'
        , breadcrumbsData: [
          {
            'title': "InvoiceInbounds.title",
          },
        ]
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 2500,
        }

      };
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElements();
        }
      },

      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

    },
    mounted() {
      const modul = this;
      modul.state = Object.assign({}, modul.$store.state);
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [18])) {
          modul.hasRole = true;
        }
        if (modul.$store.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
      },
      init(){
        const modul = this;
        modul.getElements();

      },

//      modulRowIdCb: function (data, type, row, meta) {
//        const modul = this;
//        console.log("--" + data);
//        return "" + row.identifier_pre_id + row.identifier_counter;
//      },
//      renderType(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return modul.$t("global.contacttype.businesspartner")
//        }
//        if (Number(row.id_store)>0) {
//          return modul.$t("global.contacttype.store")
//        }
//        if (Number(row.id_address)>0) {
//          return modul.$t("global.contacttype.address")
//        }
//      },
//      renderEntity(data, type, row, meta){
//        const modul = this;
//        if (Number(row.id_businesspartner)>0) {
//          return row.businesspartnerbusinesspartnername;
//        }
//        if (Number(row.id_store)>0) {
//          return row.storetext;
//        }
//        if (Number(row.id_address)>0) {
//          return row.addressname;
//        }
//      },
//      chkRole(){
//        const modul = this;
//        modul.hasRole = false;
//        const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
//        if (!Helper.checkRoles(modul.roles, role)) {
//          modul.hasRole = false;
////        modul.$router.push({name: "dashboard"})
//        } else {
//          modul.hasRole = true;
//        }
//      },
      getElements(){
        const modul = this;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.getInvoiceInboundsFinance({id_company: modul.$store.state.id_company}).then(function (res) {
          if (res && res.result) {
            modul.data = Array.from(res.data);
          }

//          const res = result;
//          modul.data = Array.from(result);
          console.log(res);

          modul.AlertInPage.msg = "";
        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      }
    },

    components: {
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      TableDatatableJs,
      MenuToggle,
      AlertInPage,
    },
  };
</script>








